/**
 * Formats a number for the provided locale with the specified number of decimal places and
 * with optional thousands separators.
 *
 * @param value - The number to format.
 * @param locale - The locale to use for formatting.
 * @param options - The options to use for formatting.
 */
export function formatNumber(
  value: number,
  locale: string,
  options: { decimalPlaces?: number; disallowGroupings?: boolean } = {},
): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: options.decimalPlaces,
    maximumFractionDigits: options.decimalPlaces,
    useGrouping: !options.disallowGroupings,
  }).format(value);
}
